class FocusedDirective {
    constructor($timeout, $rootScope) {
        this.restrict = 'A';
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
    }

    link(scope, element, attrs, controllers) {

        const onFocus = () => {
            this.$timeout(() => {
                this.$rootScope.$broadcast('focusedParam', attrs.focused);
            }, 30);
        }

        const onBlur = () => {
            this.$rootScope.$broadcast('focusedParam', null);
        }

        element.on('focus', onFocus);
        element.on('blur', onBlur);

        scope.$on('$destroy', () => {
            element.off('focus', onFocus);
            element.off('blur', onBlur);
        });
    }

    static directiveFactory($timeout, $rootScope) {
        'ngInject';
        return new FocusedDirective($timeout, $rootScope);
    }
}

export default FocusedDirective;